import { connect } from 'react-redux';
import NetWorthChartView from './NetWorthChartView';
import { chartData } from './NetWorthChartSelector';

const mapStateToProps = (state, ownProps) => {
  return {
    chartData: chartData(state, ownProps.clientId, ownProps.range),
  };
};

const NetWorthChart = connect(mapStateToProps, {})(NetWorthChartView);

export default NetWorthChart;
